<!--
 * @Author: xiehangyi
 * @LastEditors: chenming
 * @Description: 金额输入框 渲染态
-->
<template>
  <div class="lc-input-amount">
    <div class="lc-input-amount__item">
      <div v-if="magnify && showMagnify" class="lc-input-amount__magnify">
        {{ amountMagnify }}
      </div>
      <div
        v-if="currency"
        class="lc-input-amount__item-prev"
      >
        <el-select
          v-model="customCurrency"
          :disabled="disabled"
          style="width: 90px;"
          @change="handleCurrencyChange"
        >
          <el-option
            v-for="(item, index) in currencyList"
            :key="index"
            :label="item[currencyLabel]"
            :value="item[currencyValue]"
          />
        </el-select>
      </div>
      <div class="lc-input-amount__item-after">
        <el-input
          v-model.trim="amountNum"
          class="lc-input"
          v-bind="$attrs"
          type="text"
          :disabled="disabled"
          @blur="handleBlur"
          @focus="handleFocus"
          @input.native="inputMoneyFun($event)"
          @clear="$emit('clear')"
        />
      </div>
    </div>
    <!-- 金额大写 -->
    <div
      v-show="showMagnify"
      class="lc-input-amount__uppercase"
    >
      {{ currencyName }}{{ amountWord | amountInWords }}
    </div>
  </div>
</template>
<script>
import { amountInWords } from '@/utils/index';
export default {
  name: 'LcInputAmount',
  components: {},
  filters: {
    amountInWords,
  },
  props: {
    value: {
      type: [Number, String],
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    // 是否显示金额种类
    currency: {
      type: Boolean,
      default: true,
    },
    currencyLabel: {
      type: String,
      default: 'label'
    },
    currencyValue: {
      type: String,
      default: 'value'
    },
    defaultValue: {
      type: [Number, String],
      default: '',
    },
    //最大小数点位数
    maxDecimalDigits: {
      type: [Number, String],
      default: '',
    },
    //最小整数位数
    minIntegerDigits: {
      type: [Number, String],
      default: '',
    },
    //最大整数位数
    maxIntegerDigits: {
      type: [Number, String],
      default: '',
    },
    // 是否显示金额放大框
    magnify: {
      type: Boolean,
      default: true,
    },
    // 币种文字，可能会从别的组件传递过来
    currencyText: {
      type: String,
      default: '',
    },
    // 金额分隔符
    separator: {
      type: String,
      default: '',
    },
    currencyList: {
      type: Array,
      default: () => [
        {
          label: '人民币',
          value: '￥'
        }, {
          label: '美元',
          value: '$'
        }, {
          label: '欧元',
          value: '€'
        }, {
          label: '英镑',
          value: '£'
        }, {
          label: '港币',
          value: 'HK$'
        }, {
          label: '日元',
          value: 'JPY'
        }, {
          label: '澳元',
          value: 'A$'
        }
      ]
    }
  },
  data () {
    return {
      formValue: '',
      customCurrency: '￥',
      showMagnify: false,
      rules: [
        {
          validator: (rule, value, callback) => {
            if (value) {
              value += '';
              let amount = this.currency ? this.getSplitList(value)[1] : value;
              const reg = /(^\-?[0-9]*$)|(^\-?[0-9]+\.[0-9]+$)/;
              const numArr = amount.split('.');
              if (!reg.test(amount)) {
                return callback('不正确的输入项');
              }
              if (numArr[1] && numArr[1].length > this.maxDecimalDigits) {
                return callback(`格式有误，小数点后只能保留${this.maxDecimalDigits}位`);
              }
              callback();
            } else {
              callback();
            }
          },
          trigger: 'blur',
        },
      ],
    };
  },
  computed: {
    // 放大金额
    amountMagnify () {
      return this.setThousandsAmount(this.clearComma(this.amountNum));
    },
    // 币种中文
    currencyName () {
      if (this.currencyText) {
        return this.currencyText;
      }
      const currentCurrency = this.currencyList.find(item => item.value === this.customCurrency);
      if (this.currency && currentCurrency) {
        return currentCurrency.label + this.separator;
      }
      return '';
    },
    // 大写中文金额
    amountWord () {
      const amountArr = this.clearComma(this.amountNum).split('.');
      return amountArr.length > 1 ? `${amountArr[0]}.${amountArr[1].substr(0, 2)}` : amountArr[0];
    },
    amountNum: {
      get () {
        return this.splitModelValue(this.formValue);
      },
      set (value) {
        this.formValue = this.joinModelValue(this.clearComma(value));
      },
    },
  },
  watch: {
    formValue: function (val) {
      let amount = 0;
      if(this.currency) {
        const amountList = this.getSplitList(val);
        amount = parseFloat(amountList[1]);
        if(isNaN(amount)) {
          this.formValue = amountList[0] + this.separator + 0;
        }
        this.$emit('input', amountList[0] + this.separator + amount);
      } else {
        amount = parseFloat(val);
        if(isNaN(amount)) {
          this.formValue = 0;
        }
        this.$emit('input', amount);
      }
    },
  },
  created () {
    // preset
    this.formValue = this.value;
  },
  mounted () {
  },
  methods: {
    handleBlur (e) {
      this.showMagnify = false;
      e.target.value = this.setThousandsAmount(e.target.value);
    },
    handleFocus (e) {
      this.showMagnify = true;
      this.formValue && (e.target.value = this.splitModelValue(this.formValue));
    },
    handleCurrencyChange() {
      this.formValue = this.joinModelValue(this.amountNum);
    },
    // 拼接币种和金额字符串，使用空格拼接
    joinModelValue (amount) {
      return this.currency ? this.customCurrency + this.separator + amount : amount;
    },
    splitModelValue (amount) {
      if (amount === '') return;
      amount += '';
      const amountList = this.getSplitList(amount);
      if(this.currency) {
        this.customCurrency = amountList[0];
      }
      return this.currency ? (amountList.length > 1 ? amountList[1] : amountList[0]) : amount;
    },
    // 对输入金额进行判断格式是否正确，如果正确进行格式化处理，清除前面的零
    inputMoneyFun (e) {
      let amount = this.clearComma(e.target.value);
      if (!this.validateAmount(amount)) {
        return this.formValue = this.joinModelValue(amount);
      }
      this.formValue = this.joinModelValue(this.formattedAmountFun(amount));
    },
    // 格式化金额，并清除前面的零
    formattedAmountFun (val) {
      if(isNaN(parseFloat(val))) {
        return '';
      }
      const NumArr = parseFloat(val).toString().split('.');
      const maxIntegerDigits = isNaN(parseInt(this.maxIntegerDigits)) ? 15 : parseInt(this.maxIntegerDigits);
      const minIntegerDigits = isNaN(parseInt(this.minIntegerDigits)) ? 0 : parseInt(this.minIntegerDigits);
      const maxDecimalDigits = isNaN(parseInt(this.maxDecimalDigits)) ? 2 : parseInt(this.maxDecimalDigits)
      let integer = Array.isArray(NumArr) && NumArr.length > 0 ? NumArr[0].slice(0, maxIntegerDigits) : '',
        decimal = Array.isArray(NumArr) && NumArr.length === 2 ? NumArr[1].slice(0, maxDecimalDigits) : '';
      if(integer.length < minIntegerDigits) {
        this.$message.warning(`请输入最小${minIntegerDigits}位整数位数`);
      }
      if (decimal.length > 0 || (Array.isArray(NumArr) && NumArr.length >= 2)) {
        //设置了小数点位数
        return `${integer}.${decimal}`;
      } else {
        //设置整数位数
        return integer;
      }
    },
    // 转化为千分位
    setThousandsAmount (number) {
      // 转为字符串，并按照.拆分
      const arr = (number + '').split('.');
      // 整数部分再拆分
      const int = arr[0].split('');
      // 小数部分
      let fraction = arr[1] || '';
      // 返回的变量
      let amount = '';
      int.reverse().forEach(function (v, i) {
        // 非第一位并且是位值是3的倍数，添加“,”
        if (i !== 0 && i % 3 === 0) {
          amount = v + ',' + amount;
        } else {
          // 正常添加字符(这是好写法)
          amount = v + amount;
        }
      });
      if (arr.length > 2) {
        for (let i = 2; i < arr.length; i++) {
          fraction += '.' + arr[i] ?? '';
        }
      }
      // 整数部分和小数部分拼接
      return amount + (arr.length > 1 ? '.' + fraction : '');
    },
    validateAmount (value) {
      const reg = /(^\-?[0-9]*$)|(^\-?[0-9]+\.[0-9]+$)/;
      const numArr = value.split('.');
      if (!reg.test(value)) {
        return false;
      }
      if (numArr[1] && numArr[1].length > this.maxDecimalDigits) {
        return false;
      }
      return true;
    },
    // 清楚金额中的逗号
    clearComma (amount) {
      if (amount) {
        return String(amount).replace(/,/g, '');
      }
      return '';
    },
    getSplitList(amount) {
      amount += '';
      if(this.separator) {
        return amount.split(this.separator);
      }
      if(this.currency) {
        const currencyObj = this.currencyList.find(item => amount.startsWith(item.value));
        return currencyObj ? [currencyObj.value, amount.split(currencyObj.value)[1]] : [amount]
      }
      return [amount];
    }
  },
};
</script>

<style lang="scss">
@import '@/styles/element-ui.scss';
.lc-input-amount {
  @if $width == 'fullWidth' {
    width: 100%;
  } @else if $width == 'mini' {
    width: 60px;
  } @else {
    width: #{$width};
  }
  position: relative;
  .lc-input-amount__magnify {
    position: absolute;
    bottom: 100%;
    left: 0;
    right: 0;
    padding: 10px;
    margin-bottom: 5px;
    border-radius: 4px;
    word-break: break-all;
    background: #f6f6f6;
    color: #ff984c;
    font-size: 24px;
    line-height: 1;
    z-index: 100;
  }
  .lc-input-amount__uppercase {
    color: #ff984c;
    font-size: 16px;
    line-height: 1;
    padding-top: 4px;
    position: absolute;
    top: 100%;
    left: 0;
    white-space: nowrap;
  }
  .lc-input-amount__item {
    width: 100%;
    display: flex;
    justify-content: space-between;
    .lc-input-amount__item-prev {
      flex-grow: 0;
      margin-right: 10px;
    }
    .lc-input-amount__item-after {
      flex: 1;
      flex-grow: 1;
      position: relative;
      .el-input {
        width: 100%;
      }
    }
  }
}
.el-form-item.is-error {
  .lc-input-amount {
    &__uppercase {
      display: none;
    }
  }
}
</style>
